var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AnalysisTemplateTypeDto, ComputePipelineType, ComputeEngineType, ScorecardPurpose } from "@ane/exp-data/lib/resources/MetricServiceResource";
import ___default from "lodash";
import { compareIgnoreCase, getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { SupportFileType, getNameFromPath, isSupportFileWithinSize } from "./module/views/Analysis/AnalysisCreate/components/SupportFilesTab/SupportFilesForm.utils.js";
import { getCustomForayParametersFromScopeField } from "./module/views/Analysis/AnalysisCreate/components/ForayAppSettings/ForayAppSetting.utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { AnalysisFilterOperator, Origin } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
import { AnalysisUtilsInstance } from "@ane/exp-data/lib/utils/AnalysisUtils";
import { showNewPreviewScorecardExperience } from "@ane/exp-data/lib/routes/VivaceOptIn.utils";
import { getVivaceAnalysisTemplateLink } from "@ane/exp-data/lib/routes/ExternalRoute.utils";
import momentTz from "moment-timezone";
import { isValidSegmentSelectionForm } from "./module/views/Analysis/AnalysisCreate/components/SegmentsTab/SegmentSelectionForm.validation.js";
import { isValidTriggerFilterForm } from "./module/views/Analysis/AnalysisCreate/components/TriggerFilterTab/TriggerFilterForm.validation.js";
import { isWhereClauseValid } from "./module/views/Analysis/AnalysisCreate/components/WhereClauseTab/WhereClauseForm.validation.js";
import { isForayAppSettingsValid } from "./module/views/Analysis/AnalysisCreate/components/ForayAppSettings/ForayAppSettingsForm.validation.js";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import { isValidJobProfileSideStreamTriggerFilterForm } from "./module/views/Analysis/AnalysisCreate/components/TriggerFilterTab/JobProfileSideStreamTriggerForm.validation.js";
import { AnalysisOption } from "@ane/exp-data/lib/models";
const toLocal = (date, isUTC) => {
  if (EnvironmentService.enableTimeZoneFeature()) {
    if (isUTC) {
      return toLocalFromUTC(date);
    } else {
      return toLocalFromPST(date);
    }
  } else {
    return date;
  }
};
const createAnalysisRequest = (formValues, stepId, pipelineType, isUTC) => {
  var _a, _b, _c, _d;
  return __spreadProps(__spreadValues(__spreadValues({
    ExpStepId: stepId,
    WorkspaceId: formValues.workspaceId,
    AnalysisTemplateName: formValues.templateSelected,
    IsOneOffAnalysis: formValues.schedule === "one-off",
    AnalysisStart: formValues.schedule === "one-off" ? toLocal(formValues.startDateTime, isUTC) : formValues.isAutomaticAnalysisOverrideStart ? formValues.startDateTime : null,
    AnalysisEnd: formValues.schedule === "one-off" ? toLocal(formValues.endDateTime, isUTC) : null,
    AnalysisStudyName: formValues.name,
    AnalysisStudyDescription: formValues.name,
    SupportFiles: formValues.templateSelectedType === AnalysisTemplateTypeDto.ForayApp || pipelineType === ComputePipelineType.AzureSpark ? [] : formValues.scopeResourcesSupportFiles.map((s) => ({ FilePath: s, FileType: SupportFileType.ScopeResource })).concat(
      formValues.scopeReferenceSupportFiles.map((s) => ({ FilePath: s, FileType: SupportFileType.ScopeReference }))
    ),
    JobProperties: formValues.templateSelectedType === AnalysisTemplateTypeDto.ForayApp ? getForayAppJobProperties(formValues) : {
      OverrideStandardSegments: formValues.isOverrideSegment ? formValues.secondarySegmentsSelected || [] : null,
      CustomSegments: formValues.customSegments && formValues.customSegments.length > 0 ? formValues.customSegments.map((c) => ({ Name: c.name, ScopeExpression: c.expression })) : [],
      AdditionalWhereClause: formValues.isAdditionalWhereClauseEnabled && (pipelineType === ComputePipelineType.Cosmos || formValues.triggerFilterType === TriggerFilterType.Triggered) ? formValues.additionalWhereClause : null,
      ShouldOverrideStandanrdSegments: formValues.isOverrideSegment,
      SegmentByOverride: getSegmentsByOverride(formValues),
      TriggerFilterInfo: getTriggerFilterInfo$1(formValues)
    },
    CosmosPriorityOverride: formValues.templateSelectedType !== AnalysisTemplateTypeDto.ForayApp && formValues.useCustomJobPriority && pipelineType !== ComputePipelineType.AzureSpark ? formValues.customJobPriority : null,
    CosmosVcOverride: !formValues.selectedVC || compareIgnoreCase(formValues.selectedVC, "BingAB default") || formValues.templateSelectedType === AnalysisTemplateTypeDto.ForayApp || pipelineType === ComputePipelineType.AzureSpark ? null : formValues.selectedVC,
    ScorecardNotificationEnabled: formValues.emailExperimentAndJobOwners || formValues.subscribers.length > 0,
    CustomNotifyAliases: formValues.emailCustomAliases ? formValues.emailAliases : [],
    CustomData: getCustomData(formValues),
    MetricSetVersion: !!formValues.metricSetVersionId ? formValues.metricSetVersionId : null,
    RequestOwner: ((_b = (_a = EnvironmentService) == null ? void 0 : _a.getUser()) == null ? void 0 : _b.alias) === "unknown" ? void 0 : (_d = (_c = EnvironmentService) == null ? void 0 : _c.getUser()) == null ? void 0 : _d.alias,
    SideStreamModel: formValues.isJobProfileSideStreamEnabled ? {
      customSideStreamExpression: formValues.customSideStreamExpression,
      customParameters: formValues.jobProfileSideStreamCustomParameters
    } : void 0,
    CentralizedNotificationEnabled: formValues.subscribers.length > 0
  }, AnalysisUtilsInstance.isPreviewAnalysisOption(formValues.analysisTypeOption) ? { IsPreviewScorecard: true } : {}), AnalysisUtilsInstance.isPreviewAnalysisOption(formValues.analysisTypeOption) && !!formValues.metricSetName ? { MetricSet: formValues.metricSetName } : {}), {
    IsAdvancedAnalysis: formValues.isAdvancedAnalysis
  });
};
const getForayAppJobProperties = (formValues) => {
  const properties = (formValues.customForayParameters || []).map((c) => ({ PropertyName: c.key, PropertyValue: c.value }));
  if (formValues.isVerticalOverride && !!formValues.forayVertical) {
    properties.push({ PropertyName: "sv", PropertyValue: formValues.forayVertical });
  }
  return {
    Properties: properties
  };
};
const getSegmentsByOverride = (formValues) => {
  if (!formValues.isOverrideSegment || !formValues.enablePrimarySegmentSelection) {
    return null;
  }
  const segmentBy = [];
  if (!!formValues.primarySegmentSelected) {
    segmentBy.push({ AggregateAll: true, Level: 1, Segments: [{ Name: formValues.primarySegmentSelected }] });
  }
  if (!!formValues.secondarySegmentsSelected && formValues.secondarySegmentsSelected.length > 0 || formValues.customSegments.length > 0) {
    segmentBy.push({
      AggregateAll: true,
      Level: 2,
      Segments: (formValues.secondarySegmentsSelected || []).map((seg) => ({ Name: seg })),
      CustomSegments: (formValues.customSegments || []).map((c) => ({ Name: c.name, ScopeExpression: c.expression }))
    });
  }
  return segmentBy;
};
const getTriggerFilterInfo$1 = (formValue) => {
  if (!formValue.isEnabledTriggerFilter) {
    return null;
  } else if (formValue.isJobProfileSideStreamEnabled) {
    return null;
  }
  return {
    Name: formValue.triggerFilterConditionName,
    Type: formValue.triggerFilterType,
    ScopeExpression: formValue.triggerFilterExpression,
    TriggerFilterSideStreamInfo: formValue.isSideStreamEnabled ? {
      Location: formValue.sideStreamViewLocationInCosmos,
      AvailabilityStream: formValue.sideStreamAvailabilityStream,
      CustomParameters: formValue.sideStreamCustomParameters.map((c) => ({ Name: c.name, Value: c.value, Type: c.type })),
      JoinColumnPairs: ___default.reduce(
        formValue.sideStreamJoinColumns,
        (result, value) => {
          result[value.metricDataColumn] = value.sideStreamColumn;
          return result;
        },
        {}
      )
    } : null
  };
};
const getCustomData = (formValues) => {
  return {
    ModelJson: JSON.stringify({
      CustomParameters: ___default.reduce(
        formValues.templateSelectedType === AnalysisTemplateTypeDto.ForayApp ? [] : formValues.sideStreamCustomParameters || [],
        (result, current) => {
          result[current.name] = current.value;
          return result;
        },
        {}
      )
    })
  };
};
const createForayJobValidationRequest = (forayConfig, formValues) => {
  return {
    Id: getNewGuid(),
    Config: (forayConfig == null ? void 0 : forayConfig.ForayINI) || "",
    ComputeEngineType: (formValues == null ? void 0 : formValues.pipelineType) === ComputePipelineType.AzureSpark ? ComputeEngineType.Spark : ComputeEngineType.Cosmos,
    SkipOptimization: false,
    VirtualCluster: (formValues == null ? void 0 : formValues.selectedVC) || "",
    DoScopeCompile: true,
    SimplifyScopeCompile: !!(formValues == null ? void 0 : formValues.sideStreamViewLocationInCosmos),
    WorkspaceId: (formValues == null ? void 0 : formValues.workspaceId) || ""
  };
};
const parsePrimarySegments = (template) => {
  const primarySegments = findSegmentsAtLevel$1(template, 1);
  return primarySegments.length > 0 ? primarySegments[0] : "";
};
const parseSecondarySegments = (template, segmentGroupMaps) => {
  const secondarySegments = findSegmentsAtLevel$1(template, 2);
  if (secondarySegments.length > 0) {
    return secondarySegments;
  } else {
    if (!segmentGroupMaps || segmentGroupMaps.length === 0) {
      return [];
    }
    const secondarySegmentGroups = (template == null ? void 0 : template.StandardSegmentGroups) || [];
    const secondarySegments2 = [];
    secondarySegmentGroups.forEach((g) => {
      const group = segmentGroupMaps.find((sgm) => sgm.GroupName === g);
      if (!!group && group.Segments && group.Segments.length > 0) {
        secondarySegments2.push(...group.Segments);
      }
    });
    return secondarySegments2;
  }
};
const findSegmentsAtLevel$1 = (template, level) => {
  if (!template || !template.SegmentBy || template.SegmentBy.length === 0) {
    return [];
  }
  const segmentAtLevel = template.SegmentBy.find((s) => s.Level === level);
  if (!segmentAtLevel || !segmentAtLevel.Segments) {
    return [];
  }
  return segmentAtLevel.Segments.map((s) => s.Name);
};
const parseTriggerFilterCondition = (triggerFilterCondition) => {
  return {
    name: (triggerFilterCondition == null ? void 0 : triggerFilterCondition.name) || "",
    type: !!(triggerFilterCondition == null ? void 0 : triggerFilterCondition.type) ? getTriggerFilterType(triggerFilterCondition == null ? void 0 : triggerFilterCondition.type) : TriggerFilterType.Triggered,
    scopeExpression: (triggerFilterCondition == null ? void 0 : triggerFilterCondition.scopeExpression) || "",
    sideStreamInfo: {
      availabilityStream: "",
      location: "",
      customParameters: [],
      joinColumnPairs: [
        { metricDataColumn: JoinColumnPairDefaults.MetricDataColumn, sideStreamColumn: JoinColumnPairDefaults.SideStreamColumn }
      ]
    }
  };
};
const parseSideStreamInfo = (sideStreamConfig, triggerFilterConfigs) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const analysisConfigTriggerFilter = !!triggerFilterConfigs && (sideStreamConfig == null ? void 0 : sideStreamConfig.name) ? triggerFilterConfigs[sideStreamConfig == null ? void 0 : sideStreamConfig.name] : null;
  return {
    name: (sideStreamConfig == null ? void 0 : sideStreamConfig.name) || "",
    type: TriggerFilterType.Triggered,
    scopeExpression: (_a = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.Condition) != null ? _a : "",
    sideStreamInfo: {
      availabilityStream: (_b = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo.AvailabilityStream) != null ? _b : "",
      location: (_c = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo.Location) != null ? _c : "",
      customParameters: ((_f = (_e = (_d = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _d.CustomParameters) == null ? void 0 : _e.length) != null ? _f : 0) > 0 ? (((_g = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _g.CustomParameters) || []).map((s) => ({
        name: s.Name,
        value: s.Value,
        type: s.Type
      })) : [],
      joinColumnPairs: ((_j = (_i = (_h = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _h.JoinColumnPairs) == null ? void 0 : _i.length) != null ? _j : 0) > 0 ? (((_k = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _k.JoinColumnPairs) || []).map((s) => ({
        metricDataColumn: s.MetricDataColumn,
        sideStreamColumn: s.SideStreamColumn
      })) : [
        {
          metricDataColumn: JoinColumnPairDefaults.MetricDataColumn,
          sideStreamColumn: JoinColumnPairDefaults.SideStreamColumn
        }
      ]
    }
  };
};
const parseTriggerFilterInfoDto = (triggerFilterInfoDto, triggerFilterConfigs) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  if (!triggerFilterInfoDto || !triggerFilterInfoDto.SideStreamInfo) {
    return {
      name: (triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.Name) || "",
      type: !!(triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.AnalysisFilterType) ? getTriggerFilterType(triggerFilterInfoDto.AnalysisFilterType) : TriggerFilterType.Triggered,
      scopeExpression: (triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.ScopeExpression) || "",
      sideStreamInfo: {
        availabilityStream: "",
        location: "",
        customParameters: [],
        joinColumnPairs: [{ metricDataColumn: "main_stream_column", sideStreamColumn: "side_stream_column" }]
      }
    };
  }
  const analysisConfigTriggerFilter = !!triggerFilterConfigs && (triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.Name) ? triggerFilterConfigs[triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.Name] : null;
  return {
    name: (triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.Name) || "",
    type: !!(triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.AnalysisFilterType) ? getTriggerFilterType(triggerFilterInfoDto.AnalysisFilterType) : TriggerFilterType.Triggered,
    scopeExpression: (_b = (_a = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.Condition) != null ? _a : triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.ScopeExpression) != null ? _b : "",
    sideStreamInfo: {
      availabilityStream: (_d = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo.AvailabilityStream) != null ? _d : (_c = triggerFilterInfoDto.SideStreamInfo) == null ? void 0 : _c.AvailabilityStream,
      location: (_f = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo.Location) != null ? _f : (_e = triggerFilterInfoDto.SideStreamInfo) == null ? void 0 : _e.Location,
      customParameters: ((_i = (_h = (_g = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _g.CustomParameters) == null ? void 0 : _h.length) != null ? _i : 0) > 0 ? (((_j = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _j.CustomParameters) || []).map((s) => ({
        name: s.Name,
        value: s.Value,
        type: s.Type
      })) : ((_l = (_k = triggerFilterInfoDto.SideStreamInfo) == null ? void 0 : _k.CustomParameters) != null ? _l : []).map((c) => ({
        name: c.Name,
        type: c.Type,
        value: c.Value
      })),
      joinColumnPairs: ((_o = (_n = (_m = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _m.JoinColumnPairs) == null ? void 0 : _n.length) != null ? _o : 0) > 0 ? (((_p = analysisConfigTriggerFilter == null ? void 0 : analysisConfigTriggerFilter.SideStreamInfo) == null ? void 0 : _p.JoinColumnPairs) || []).map((s) => ({
        metricDataColumn: s.MetricDataColumn,
        sideStreamColumn: s.SideStreamColumn
      })) : ___default.keys((_r = (_q = triggerFilterInfoDto.SideStreamInfo) == null ? void 0 : _q.JoinColumnPairs) != null ? _r : {}).map((k) => {
        var _a2, _b2;
        return {
          metricDataColumn: k,
          sideStreamColumn: (_b2 = (_a2 = triggerFilterInfoDto == null ? void 0 : triggerFilterInfoDto.SideStreamInfo) == null ? void 0 : _a2.JoinColumnPairs[k]) != null ? _b2 : ""
        };
      })
    }
  };
};
const getInitialCreateFormValues = (studyData) => {
  if (!studyData) {
    return {};
  }
  const isForayApp = studyData.Scope.AnalysisType === "ForayApp";
  if (isForayApp) {
    return getForayAppInitialCreateFormValues(studyData);
  } else {
    return getABInitialCreateFormValues(studyData);
  }
};
const getCommonInitialCreateFormValues = (studyData) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const isOneOff = ___default.some(((_a = studyData == null ? void 0 : studyData.TaskSchedule) == null ? void 0 : _a.Tasks) || [], (t) => {
    var _a2, _b2;
    return ((_a2 = t == null ? void 0 : t.DateRange) == null ? void 0 : _a2.Start) === null && ((_b2 = t.DateRange) == null ? void 0 : _b2.End) === null;
  });
  return {
    name: (_b = studyData == null ? void 0 : studyData.Description) != null ? _b : "",
    templateSelected: (_c = studyData == null ? void 0 : studyData.BaseOnTemplate) != null ? _c : "",
    metricSetVersionId: (_d = studyData == null ? void 0 : studyData.MetricSetVersion) != null ? _d : "",
    schedule: isOneOff ? "one-off" : "automatic",
    startDateTime: !!((_e = studyData == null ? void 0 : studyData.TaskSchedule) == null ? void 0 : _e.StartDate) ? new Date(studyData.TaskSchedule.StartDate) : void 0,
    endDateTime: isOneOff && !!((_f = studyData == null ? void 0 : studyData.TaskSchedule) == null ? void 0 : _f.EndDate) ? new Date(studyData.TaskSchedule.EndDate) : void 0,
    isAutomaticAnalysisOverrideStart: !isOneOff && !!((_g = studyData == null ? void 0 : studyData.TaskSchedule) == null ? void 0 : _g.StartDate)
  };
};
const getForayAppInitialCreateFormValues = (studyData) => {
  var _a, _b, _c, _d, _e, _f;
  const userDefinedVertical = (_b = (_a = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _a.Filters) == null ? void 0 : _b.find((f) => f.Dimension === "SV" && f.Origin === "UserDefined");
  const parameters = (_d = (_c = studyData.Scope) == null ? void 0 : _c.Filters) == null ? void 0 : _d.filter((f) => f.Dimension.startsWith("ForayApp.Parameter"));
  const customForayParameters = getCustomForayParametersFromScopeField(parameters);
  return __spreadProps(__spreadValues({}, getCommonInitialCreateFormValues(studyData)), {
    templateSelectedType: AnalysisTemplateTypeDto.ForayApp,
    templateListType: "regular",
    isVerticalOverride: !!userDefinedVertical,
    forayVertical: !!userDefinedVertical && ((_f = (_e = userDefinedVertical == null ? void 0 : userDefinedVertical.Values) == null ? void 0 : _e.length) != null ? _f : 0) > 0 ? userDefinedVertical[0] : "",
    customForayParameters
  });
};
const getABInitialCreateFormValues = (studyData) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T;
  const firstTask = !!((_a = studyData.TaskSchedule) == null ? void 0 : _a.Tasks) && ((_d = (_c = (_b = studyData.TaskSchedule) == null ? void 0 : _b.Tasks) == null ? void 0 : _c.length) != null ? _d : 0) > 0 ? studyData.TaskSchedule.Tasks.find((t) => t.Priority === "Normal") || studyData.TaskSchedule.Tasks[0] : null;
  const level1Segment = (_h = (_g = (_f = (_e = firstTask == null ? void 0 : firstTask.AnalysisConfiguration) == null ? void 0 : _e.SegmentBy) == null ? void 0 : _f.find((s) => s.Level === 1)) == null ? void 0 : _g.Segments) != null ? _h : [];
  const segment = level1Segment.length > 0 ? level1Segment[0].Name : "";
  const customSegments = !!firstTask ? (_k = (_j = (_i = firstTask.AnalysisConfiguration) == null ? void 0 : _i.CustomSegments) == null ? void 0 : _j.map((c) => ({ name: c.Name, expression: c.ScopeExpression }))) != null ? _k : [] : [];
  const whereClauseFilter = (_m = (_l = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _l.Filters) == null ? void 0 : _m.find((f) => f.Operator === "CustomWhere");
  const whereClause = getFilterValue(whereClauseFilter);
  const userTrigger = (_o = (_n = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _n.Filters) == null ? void 0 : _o.find((f) => f.Operator === "CustomTriggerOn");
  const filter = (_q = (_p = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _p.Filters) == null ? void 0 : _q.find((f) => f.Operator === "CustomFilterOn");
  const userTriggerCompliment = (_s = (_r = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _r.Filters) == null ? void 0 : _s.find((f) => f.Operator === "CustomTriggerComplementOn");
  const sessionTrigger = (_u = (_t = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _t.Filters) == null ? void 0 : _u.find((f) => f.Operator === "CustomSessionTriggerOn");
  const triggerFilterType = !!userTrigger ? TriggerFilterType.Triggered : !!filter ? TriggerFilterType.Filtered : !!userTriggerCompliment ? TriggerFilterType.UserTrigComp : !!sessionTrigger ? TriggerFilterType.SessTrig : null;
  const triggerFilterInfo = (_x = (_w = (_v = userTrigger != null ? userTrigger : filter) != null ? _v : userTriggerCompliment) != null ? _w : sessionTrigger) != null ? _x : null;
  const sideStreamInfo = triggerFilterInfo == null ? void 0 : triggerFilterInfo.TriggerFilterSideStreamInfo;
  const additionalContextInfo = !!studyData.AdditionalContext ? JSON.parse(studyData.AdditionalContext) : "";
  const jobProfileSideStreamModel = !!additionalContextInfo && additionalContextInfo.sideStreamModel;
  return __spreadValues(__spreadProps(__spreadValues({}, getCommonInitialCreateFormValues(studyData)), {
    templateSelectedType: AnalysisTemplateTypeDto.AB,
    templateListType: "regular",
    isOverrideSegment: !!((_y = firstTask == null ? void 0 : firstTask.AnalysisConfiguration) == null ? void 0 : _y.Segments),
    secondarySegmentsSelected: getSecondarySegments(firstTask),
    customSegments,
    primarySegmentSelected: segment,
    isEnabledTriggerFilter: !!triggerFilterType,
    triggerFilterConditionName: triggerFilterInfo == null ? void 0 : triggerFilterInfo.Dimension,
    triggerFilterType: triggerFilterType || TriggerFilterType.Triggered,
    triggerFilterExpression: getFilterValue(triggerFilterInfo),
    isSideStreamEnabled: !!sideStreamInfo,
    sideStreamViewLocationInCosmos: (_z = sideStreamInfo == null ? void 0 : sideStreamInfo.Location) != null ? _z : "",
    sideStreamAvailabilityStream: (_A = sideStreamInfo == null ? void 0 : sideStreamInfo.AvailabilityStream) != null ? _A : "",
    sideStreamJoinColumns: ___default.map(___default.keys((_B = sideStreamInfo == null ? void 0 : sideStreamInfo.JoinColumnPairs) != null ? _B : {}), (k) => ({
      metricDataColumn: k,
      sideStreamColumn: sideStreamInfo == null ? void 0 : sideStreamInfo.JoinColumnPairs[k]
    })),
    sideStreamCustomParameters: ___default.map((_C = sideStreamInfo == null ? void 0 : sideStreamInfo.CustomParameters) != null ? _C : [], (c) => ({
      name: c.Name,
      value: c.Value,
      type: c.Type
    })),
    scopeReferenceSupportFiles: ((_E = (_D = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _D.SupportFiles) != null ? _E : []).filter((s) => s.FileType === "ScopeReference").map((s) => s.FilePath),
    scopeReferenceFiles: ((_G = (_F = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _F.SupportFiles) != null ? _G : []).filter((s) => s.FileType === "ScopeReference").map((f) => ({ name: getNameFromPath(f.FilePath), remotePath: f.FilePath })),
    scopeResourcesSupportFiles: ((_I = (_H = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _H.SupportFiles) != null ? _I : []).filter((s) => s.FileType === "ScopeResource").map((s) => s.FilePath),
    scopeResourcesFiles: ((_K = (_J = studyData == null ? void 0 : studyData.Scope) == null ? void 0 : _J.SupportFiles) != null ? _K : []).filter((s) => s.FileType === "ScopeResource").map((f) => ({ name: getNameFromPath(f.FilePath), remotePath: f.FilePath })),
    isAdditionalWhereClauseEnabled: !!whereClause,
    additionalWhereClause: whereClause,
    selectedVC: (_M = (_L = firstTask == null ? void 0 : firstTask.ExecutionConfigurationOverrides) == null ? void 0 : _L.VC) != null ? _M : "",
    useCustomJobPriority: ((_N = firstTask == null ? void 0 : firstTask.ExecutionConfigurationOverrides) == null ? void 0 : _N.CosmosPriority) !== 1e3,
    customJobPriority: (_P = (_O = firstTask == null ? void 0 : firstTask.ExecutionConfigurationOverrides) == null ? void 0 : _O.CosmosPriority) != null ? _P : 1e3,
    emailExperimentAndJobOwners: (_Q = firstTask == null ? void 0 : firstTask.ScorecardNotificationEnabled) != null ? _Q : false,
    emailAliases: (_R = firstTask == null ? void 0 : firstTask.CustomNotifyAliases) != null ? _R : [],
    emailCustomAliases: ((_T = (_S = firstTask == null ? void 0 : firstTask.CustomNotifyAliases) == null ? void 0 : _S.length) != null ? _T : 0) > 0 ? true : false
  }), !!jobProfileSideStreamModel ? {
    customSideStreamExpression: jobProfileSideStreamModel.customSideStreamExpression,
    jobProfileSideStreamCustomParameters: jobProfileSideStreamModel && ___default.map(jobProfileSideStreamModel.customParameters, (c) => ({
      name: c.name,
      value: c.value,
      type: c.type
    }))
  } : {});
};
const getSecondarySegments = (task) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  let segments = (_e = (_d = (_c = (_b = (_a = task == null ? void 0 : task.AnalysisConfiguration) == null ? void 0 : _a.SegmentBy) == null ? void 0 : _b.find((s) => s.Level === 2)) == null ? void 0 : _c.Segments) == null ? void 0 : _d.map((s) => s.Name)) != null ? _e : [];
  segments.push(...(_h = (_g = (_f = task == null ? void 0 : task.AnalysisConfiguration) == null ? void 0 : _f.Segments) == null ? void 0 : _g.filter((s) => !!s && segments.indexOf(s) === -1)) != null ? _h : []);
  return segments;
};
const getFilterValue = (filtersEntity) => {
  return !!filtersEntity && (filtersEntity == null ? void 0 : filtersEntity.Values) && filtersEntity.Values.length > 0 ? filtersEntity.Values[0] : "";
};
const convertToAnalysisCreateV2 = (analysisCreateRequest) => ({
  name: analysisCreateRequest.AnalysisStudyDescription || "",
  experimentMetadata: { experimentStepId: analysisCreateRequest.ExpStepId || "", variants: [] },
  analysisPeriod: { startDateTime: analysisCreateRequest.AnalysisStart, endDateTime: analysisCreateRequest.AnalysisEnd },
  analysisTemplate: getAnalysisTemplateContractV2(analysisCreateRequest),
  analysisFilters: getAnalysisFiltersV2(analysisCreateRequest.JobProperties),
  supportFiles: getSupportFiles(analysisCreateRequest.SupportFiles),
  sideStreamModel: analysisCreateRequest.SideStreamModel,
  isAdvancedAnalysis: analysisCreateRequest.IsAdvancedAnalysis
});
const getSupportFiles = (supportFiles) => {
  if (!supportFiles) {
    return [];
  }
  return supportFiles.map((sf) => {
    return {
      filePath: sf.FilePath,
      fileType: sf.FileType === SupportFileType.ScopeReference ? SupportFileType.ScopeReference : SupportFileType.ScopeResource
    };
  });
};
const getAnalysisTemplateContractV2 = (analysisCreateRequest) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return __spreadValues({
    name: analysisCreateRequest.AnalysisTemplateName || "",
    metricSetVersion: analysisCreateRequest.MetricSetVersion || "",
    analysisTemplateOverrides: {
      isOneOff: !!analysisCreateRequest.IsOneOffAnalysis,
      segmentBy: ((_a = analysisCreateRequest.JobProperties) == null ? void 0 : _a.ShouldOverrideStandanrdSegments) ? getSegmentByContractV2((_b = analysisCreateRequest.JobProperties) == null ? void 0 : _b.SegmentByOverride) : [],
      secondarySegments: ((_c = analysisCreateRequest.JobProperties) == null ? void 0 : _c.ShouldOverrideStandanrdSegments) ? ((_d = analysisCreateRequest.JobProperties) == null ? void 0 : _d.OverrideStandardSegments) || [] : [],
      overrideSecondarySegments: (_f = (_e = analysisCreateRequest.JobProperties) == null ? void 0 : _e.ShouldOverrideStandanrdSegments) != null ? _f : false,
      overrideTriggerFilters: true,
      // This should be always true from UX as by default we populate analysis template values in UX (if available) and user would have option to enable or disable.
      customSegments: getCustomSegmentsContractV2((_g = analysisCreateRequest.JobProperties) == null ? void 0 : _g.CustomSegments),
      notificationConfig: {
        scorecardNotificationEnabled: analysisCreateRequest.ScorecardNotificationEnabled,
        notifiers: (_h = analysisCreateRequest.CustomNotifyAliases) != null ? _h : [],
        centralizedNotificationEnabled: analysisCreateRequest.CentralizedNotificationEnabled
      },
      computeConfig: {
        vc: analysisCreateRequest.CosmosVcOverride,
        cosmosPriority: analysisCreateRequest.CosmosPriorityOverride,
        isPreviewScorecard: !!analysisCreateRequest.IsPreviewScorecard
      }
    }
  }, showNewPreviewScorecardExperience() && !!analysisCreateRequest.MetricSet ? { metricSetName: analysisCreateRequest.MetricSet } : {});
};
const getSegmentByContractV2 = (segmentSets) => {
  if (!(segmentSets == null ? void 0 : segmentSets.length)) {
    return [];
  }
  return segmentSets.map((ss) => {
    return {
      aggregateAll: ss.AggregateAll,
      level: ss.Level,
      customSegments: getCustomSegmentsContractV2(ss.CustomSegments),
      segments: ss.Segments.map((segment) => ({ name: segment.Name })),
      segmentGroups: []
      //Segment Groups are not from UX selection.
    };
  });
};
const getCustomSegmentsContractV2 = (customSegments) => {
  if (!(customSegments == null ? void 0 : customSegments.length)) {
    return [];
  }
  return customSegments.map((cs) => {
    return { name: cs.Name, scopeExpression: cs.ScopeExpression };
  });
};
const getAnalysisFiltersV2 = (jobProperties) => {
  var _a, _b;
  if (!jobProperties) {
    return [];
  }
  let filters = [];
  if (jobProperties.AdditionalWhereClause) {
    filters.push({
      name: "WHERE",
      values: [jobProperties.AdditionalWhereClause || ""],
      operator: AnalysisFilterOperator.CustomWhere,
      origin: Origin.UserDefined
    });
  }
  if ((jobProperties.Properties || []).length) {
    (_a = jobProperties.Properties) == null ? void 0 : _a.forEach(
      (forayAppProperty) => filters.push({
        name: forayAppProperty.PropertyName,
        values: [forayAppProperty.PropertyValue],
        operator: AnalysisFilterOperator.EqualTo,
        origin: Origin.UserDefined
      })
    );
  }
  if (jobProperties.TriggerFilterInfo) {
    filters.push({
      name: jobProperties.TriggerFilterInfo.Name || "",
      values: [jobProperties.TriggerFilterInfo.ScopeExpression || ""],
      triggerFilterSideStreamInfo: getTriggerFilterSideStreamInfoV2(jobProperties.TriggerFilterInfo.TriggerFilterSideStreamInfo),
      operator: getTriggerFilterTypeV2((_b = jobProperties.TriggerFilterInfo) == null ? void 0 : _b.Type),
      origin: Origin.UserDefined
    });
  }
  return filters;
};
const getTriggerFilterSideStreamInfoV2 = (triggerFilterSideStreamInfo) => {
  if (!triggerFilterSideStreamInfo) {
    return null;
  }
  return {
    joinColumnPairs: triggerFilterSideStreamInfo.JoinColumnPairs,
    availabilityStream: triggerFilterSideStreamInfo.AvailabilityStream,
    location: triggerFilterSideStreamInfo.Location,
    customParameters: triggerFilterSideStreamInfo.CustomParameters.map((customParam) => {
      return { name: customParam.Name, type: customParam.Type, value: customParam.Value };
    })
  };
};
const getTriggerFilterTypeV2 = (value) => {
  switch (value) {
    case "Filter":
      return AnalysisFilterOperator.CustomFilterOn;
    case "TriggerComplement":
      return AnalysisFilterOperator.CustomTriggerComplementOn;
    case "SessionTrigger":
      return AnalysisFilterOperator.CustomSessionTriggerOn;
    default:
      return AnalysisFilterOperator.CustomTriggerOn;
  }
};
const MIN_ANALYSIS_PERIOD_IN_MINS = 5;
const isValidAnalysisDateTab = (values, analysisWindowStart, analysisWindowEnd, template) => {
  const getDate = (localDate) => {
    if (EnvironmentService.enableTimeZoneFeature()) {
      if (template == null ? void 0 : template.isUTC) {
        return toUTC(localDate);
      } else {
        return toPST(localDate);
      }
    } else {
      return localDate;
    }
  };
  const getTimeZoneEnding = (localDate) => {
    if (EnvironmentService.enableTimeZoneFeature()) {
      if (template == null ? void 0 : template.isUTC) {
        return getTimeZoneEndingUTC(localDate);
      } else {
        return getTimeZoneEndingPST(localDate);
      }
    } else {
      return localDate == null ? void 0 : localDate.toString();
    }
  };
  let errors = {};
  const dataSourceRetentionDays = template == null ? void 0 : template.dataSourceRetentionDays;
  let dataSourceEarliestAvailableDate = null;
  let dataSourceRetentionErrorMessage = "";
  if (!!dataSourceRetentionDays) {
    dataSourceEarliestAvailableDate = /* @__PURE__ */ new Date();
    dataSourceEarliestAvailableDate.setDate(dataSourceEarliestAvailableDate.getDate() - dataSourceRetentionDays);
    const firstDataSourceName = !!(template == null ? void 0 : template.dataSourceNames) && (template == null ? void 0 : template.dataSourceNames.length) > 0 ? template == null ? void 0 : template.dataSourceNames[0] : "";
    dataSourceRetentionErrorMessage = `The data source ${firstDataSourceName} used in the analysis template ${template == null ? void 0 : template.name} has data retention set to ${dataSourceRetentionDays} days. Creating an analysis is possible only for the date-ranges that fall within the retention period.`;
    if (!!(template == null ? void 0 : template.dataSourceRetentionErrorMessage)) {
      dataSourceRetentionErrorMessage = dataSourceRetentionErrorMessage + " " + template.dataSourceRetentionErrorMessage;
    }
  }
  if (values.schedule === "automatic") {
    if (values.isAutomaticAnalysisOverrideStart) {
      if (!values.startDateTime) {
        errors.startDateTime = "Required";
      } else if (!!analysisWindowStart && values.startDateTime < new Date(analysisWindowStart)) {
        errors.startDateTime = `Analysis start time should be greater than experiment step start time : ${analysisWindowStart.toString()}`;
      } else if (!!dataSourceEarliestAvailableDate && values.startDateTime && values.startDateTime < dataSourceEarliestAvailableDate) {
        errors.startDateTime = dataSourceRetentionErrorMessage;
      }
    } else if (!!dataSourceEarliestAvailableDate && values.startDateTime && values.startDateTime < dataSourceEarliestAvailableDate) {
      errors.startDateTime = dataSourceRetentionErrorMessage;
    }
  } else if (values.schedule === "one-off") {
    if (!values.startDateTime) {
      errors.startDateTime = "Required";
    } else if (!values.endDateTime) {
      errors.endDateTime = "Required";
    } else if (!!analysisWindowStart && values.startDateTime < (getDate(new Date(analysisWindowStart)) || /* @__PURE__ */ new Date())) {
      errors.startDateTime = `Analysis start time should be greater than experiment step start time : ${getTimeZoneEnding(getDate(new Date(analysisWindowStart)))}`;
    } else if (!!analysisWindowEnd && !values.isAdvancedAnalysis && values.endDateTime > (getDate(new Date(analysisWindowEnd)) || /* @__PURE__ */ new Date())) {
      errors.endDateTime = `Analysis end time cannot be greater than experiment analysis window end time : ${getTimeZoneEnding(getDate(new Date(analysisWindowEnd)))}`;
    } else if (values.startDateTime > values.endDateTime) {
      errors.startDateTime = `Analysis start time should be less than analysis end time`;
    } else if (values.endDateTime.getTime() - values.startDateTime.getTime() < MIN_ANALYSIS_PERIOD_IN_MINS * 60 * 1e3) {
      errors.startDateTime = `Analysis period needs to be at least ${MIN_ANALYSIS_PERIOD_IN_MINS} mins`;
    } else if (!!dataSourceEarliestAvailableDate && values.startDateTime < dataSourceEarliestAvailableDate) {
      errors.startDateTime = dataSourceRetentionErrorMessage;
    }
  }
  return errors;
};
const isValidSideStreamForm = (values) => {
  var _a, _b;
  let errors = {};
  if (values.isSideStreamEnabled && values.isEnabledTriggerFilter) {
    if (!((_a = values.sideStreamViewLocationInCosmos) == null ? void 0 : _a.trim())) {
      errors.sideStreamViewLocationInCosmos = "View location in Cosmos is required";
    } else if (containsNonAsciiCharacters(values.sideStreamViewLocationInCosmos)) {
      errors.sideStreamViewLocationInCosmos = `View location in Cosmos cannot contain non-ascii characters`;
    }
    if (!((_b = values.sideStreamAvailabilityStream) == null ? void 0 : _b.trim())) {
      errors.sideStreamAvailabilityStream = "Availability stream is required";
    } else if (containsNonAsciiCharacters(values.sideStreamAvailabilityStream)) {
      errors.sideStreamAvailabilityStream = `Availability stream cannot contain non-ascii characters`;
    }
    if (!values.sideStreamJoinColumns || values.sideStreamJoinColumns.length === 0) {
      errors.sideStreamJoinColumnsErrors = "At least one sidestream join column required";
    } else {
      errors.sideStreamJoinColumns = ___default.map(values.sideStreamJoinColumns, (s, i) => {
        var _a2, _b2;
        let insideError = {};
        if (!((_a2 = s.metricDataColumn) == null ? void 0 : _a2.trim())) {
          insideError.metricDataColumn = "Join column is required";
        }
        if (!((_b2 = s.sideStreamColumn) == null ? void 0 : _b2.trim())) {
          insideError.sideStreamColumn = "Join column is required";
        }
        return insideError;
      });
      if (!___default.some(errors.sideStreamJoinColumns, (s) => !!s.metricDataColumn || !!s.sideStreamColumn)) {
        delete errors.sideStreamJoinColumns;
      }
    }
    errors.sideStreamCustomParameters = ___default.map(values.sideStreamCustomParameters, (s, i) => {
      var _a2;
      let insideError = {};
      if (!((_a2 = s.value) == null ? void 0 : _a2.trim())) {
        insideError.value = "Custom parameter is required";
      }
      return insideError;
    });
    if (!___default.some(errors.sideStreamCustomParameters, (s) => !!s.value)) {
      delete errors.sideStreamCustomParameters;
    }
  }
  return errors;
};
var TriggerFilterType = /* @__PURE__ */ ((TriggerFilterType2) => {
  TriggerFilterType2["Filtered"] = "Filter";
  TriggerFilterType2["Triggered"] = "Trigger";
  TriggerFilterType2["UserTrigComp"] = "TriggerComplement";
  TriggerFilterType2["SessTrig"] = "SessionTrigger";
  return TriggerFilterType2;
})(TriggerFilterType || {});
const getTriggerFilterType = (value) => {
  if (!value) {
    return "Trigger";
  }
  switch (value) {
    case "Filter":
      return "Filter";
    case "Trigger":
      return "Trigger";
    case "TriggerComplement":
      return "TriggerComplement";
    case "SessionTrigger":
      return "SessionTrigger";
    default:
      return "Trigger";
  }
};
var JoinColumnPairDefaults = /* @__PURE__ */ ((JoinColumnPairDefaults2) => {
  JoinColumnPairDefaults2["MetricDataColumn"] = "main_stream_column";
  JoinColumnPairDefaults2["SideStreamColumn"] = "side_stream_column";
  return JoinColumnPairDefaults2;
})(JoinColumnPairDefaults || {});
var CustomParameterDefaults = /* @__PURE__ */ ((CustomParameterDefaults2) => {
  CustomParameterDefaults2["name"] = "";
  CustomParameterDefaults2["type"] = "";
  CustomParameterDefaults2["value"] = "";
  return CustomParameterDefaults2;
})(CustomParameterDefaults || {});
const AnalysisCreateFormSettings = {
  mapPropsToValues: (props) => {
    var _a, _b, _c, _d, _e;
    const analysisWindowStart = ((_b = (_a = props.requestForm) == null ? void 0 : _a.StepProperty) == null ? void 0 : _b.AnalysisWindowStart) || void 0;
    let analysisStartDate = analysisWindowStart ? new Date(analysisWindowStart) : void 0;
    if (!!analysisStartDate) {
      analysisStartDate.setMinutes(analysisStartDate.getMinutes() + 5);
      analysisStartDate = sanitizeOneOffTime(analysisStartDate);
    }
    const analysisWindowEnd = ((_d = (_c = props.requestForm) == null ? void 0 : _c.StepProperty) == null ? void 0 : _d.AnaysisWindowEnd) || void 0;
    let analysisEndDate = analysisWindowEnd ? new Date(analysisWindowEnd) : void 0;
    if (!!analysisEndDate) {
      analysisEndDate.setMinutes(analysisEndDate.getMinutes() - 5);
      analysisEndDate = sanitizeOneOffTime(analysisEndDate);
    }
    let createFormData = {};
    if (props.studyId && ((_e = props.studyDataAsync) == null ? void 0 : _e.status) === AsyncRequestStatus.Completed) {
      createFormData = getInitialCreateFormValues(props.studyDataAsync.data);
    }
    let analysisTypeOption = AnalysisOption.ProductionAnalysis;
    let metricSetName = "";
    let metricSetVersionName = "";
    let metricSetVersionId = "";
    if (showNewPreviewScorecardExperience() && !!props.metricSetFromURL) {
      analysisTypeOption = AnalysisOption.PreviewAnalysis;
      metricSetName = props.metricSetFromURL;
      if (!!props.metricSetVersionNameFromURL) {
        metricSetVersionName = props.metricSetVersionNameFromURL;
        metricSetVersionId = AnalysisUtilsInstance.getMetricSetVersionIdFromName(
          props.metricSetVersionDictAsync[metricSetName].data,
          metricSetVersionName
        );
      } else if (!!props.metricSetVersionIdFromURL) {
        metricSetVersionId = props.metricSetVersionIdFromURL;
        metricSetVersionName = getMetricSetVersionNameFromVersionId(
          props.metricSetVersionDictAsync[metricSetName].data,
          metricSetVersionId
        );
      }
    }
    return __spreadValues({
      name: "",
      templateSelected: "",
      templateListType: "default",
      templateSelectedType: AnalysisTemplateTypeDto.AB,
      isMetricServiceTemplate: false,
      metricSetName,
      metricSetVersionId,
      metricSetVersionName,
      schedule: "automatic",
      isAutomaticAnalysisOverrideStart: false,
      startDateTime: analysisStartDate,
      endDateTime: analysisEndDate,
      isOverrideSegment: false,
      enablePrimarySegmentSelection: props.enablePrimarySegmentSelection,
      primarySegmentSelected: "",
      secondarySegmentsSelected: [],
      scopeReferenceSupportFiles: [],
      scopeReferenceFiles: [],
      scopeResourcesSupportFiles: [],
      scopeResourcesFiles: [],
      customSegments: [],
      isEnabledTriggerFilter: false,
      triggerFilterConditionName: "",
      triggerFilterType: "Trigger",
      triggerFilterSelectedExpressionTemplate: "",
      triggerFilterExpression: "",
      isAdditionalWhereClauseEnabled: false,
      additionalWhereClause: "",
      selectedVC: "",
      useCustomJobPriority: false,
      customJobPriority: 1e3,
      emailExperimentAndJobOwners: false,
      emailCustomAliases: false,
      emailAliases: [],
      isSideStreamEnabled: false,
      sideStreamTemplateOptions: [],
      selectedSideStreamTemplate: "",
      sideStreamViewLocationInCosmos: "",
      sideStreamAvailabilityStream: "",
      sideStreamJoinColumns: [
        {
          metricDataColumn: "main_stream_column",
          sideStreamColumn: "side_stream_column"
          /* SideStreamColumn */
        }
      ],
      sideStreamJoinColumnsErrors: "",
      sideStreamCustomParameters: [],
      customSideStreamExpression: "",
      jobProfileSideStreamCustomParameters: [],
      isJobProfileSideStreamEnabled: false,
      jobProfilesSideStreamInfo: [],
      isValidationSkipped: false,
      isMergedJobProfilePresent: false,
      customForayParameters: [],
      isVerticalOverride: false,
      forayVertical: "",
      workspaceId: props.workspaceId,
      subscribers: [],
      analysisTypeOption,
      isAdvancedAnalysis: false
    }, createFormData);
  },
  validate: (values, props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    let errors = {};
    const template = AnalysisUtilsInstance.isPreviewAnalysisOption(values == null ? void 0 : values.analysisTypeOption) ? getAnalysisTemplateV2(values == null ? void 0 : values.templateSelected, props.templateFromVersionDictAsync) : getAnalysisTemplateV2(values == null ? void 0 : values.templateSelected, props.templateNameV2DictAsync);
    const computePipelineType = template && getComputePipelineFromDataSource(template);
    const pipelineType = (_a = computePipelineType != null ? computePipelineType : template == null ? void 0 : template.computePipeline) != null ? _a : ComputePipelineType.Cosmos;
    if (!values.name) {
      errors.name = "Required";
    } else if (values.name.length > 3e3) {
      errors.name = "Name should be less than 3000 character";
    }
    if (!values.templateSelected) {
      errors.templateSelected = "Required";
    }
    const analysisType = (template == null ? void 0 : template.analysisType) || AnalysisTemplateTypeDto.AB;
    if (isAnalysisDatesSupported(analysisType)) {
      const analysisWindowStart = ((_c = (_b = props.requestForm) == null ? void 0 : _b.StepProperty) == null ? void 0 : _c.AnalysisWindowStart) || void 0;
      const analysisWindowEnd = ((_e = (_d = props.requestForm) == null ? void 0 : _d.StepProperty) == null ? void 0 : _e.AnaysisWindowEnd) || void 0;
      errors = __spreadValues(__spreadValues({}, errors), isValidAnalysisDateTab(values, analysisWindowStart, analysisWindowEnd, template));
    }
    if (values.templateSelectedType !== AnalysisTemplateTypeDto.ForayApp) {
      if (isSegmentsSupported(analysisType)) {
        errors = __spreadValues(__spreadValues({}, errors), isValidSegmentSelectionForm(values));
      }
      if (isTriggerFilterSupported(analysisType)) {
        errors = __spreadValues(__spreadValues({}, errors), isValidTriggerFilterForm(values));
      }
      if (isWhereClauseSupported(analysisType)) {
        errors = __spreadValues(__spreadValues({}, errors), isWhereClauseValid(values));
      }
      if (isSupportFilesSupported(analysisType)) {
        errors = __spreadValues(__spreadValues({}, errors), isSupportFileWithinSize(values));
      }
      if (values.isJobProfileSideStreamEnabled) {
        errors = __spreadValues(__spreadValues({}, errors), isValidJobProfileSideStreamTriggerFilterForm(values));
      } else if (isSideStreamSupported(values.triggerFilterType, props.requestForm, pipelineType, props.isStudio)) {
        errors = __spreadValues(__spreadValues({}, errors), isValidSideStreamForm(values));
      }
      if (isValidationNeeded(values)) {
        if (Object.keys(errors).length > 0) {
          errors = __spreadProps(__spreadValues({}, errors), {
            isValidationSkipped: "Please fix errors in other tabs before validation"
          });
        }
        const isValidationError = !values.isValidationSkipped && !((_g = (_f = props.forayValidationResponseAsync) == null ? void 0 : _f.data) == null ? void 0 : _g.IsValid);
        if (isValidationError) {
          errors = __spreadProps(__spreadValues({}, errors), {
            isValidationSkipped: "The configured trigger/filter condition did not pass the validation. The diagnostic message below may be helpful in identifying the root cause. Please update your condition and re-run the validation to proceed."
          });
        }
      }
    } else {
      errors = __spreadValues(__spreadValues({}, errors), isForayAppSettingsValid(values));
    }
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    const template = AnalysisUtilsInstance.isPreviewAnalysisOption(values == null ? void 0 : values.analysisTypeOption) ? getAnalysisTemplateV2(values == null ? void 0 : values.templateSelected, bag.props.templateFromVersionDictAsync) : getAnalysisTemplateV2(values == null ? void 0 : values.templateSelected, bag.props.templateNameV2DictAsync);
    const pipelineType = (template == null ? void 0 : template.computePipeline) || ComputePipelineType.Cosmos;
    bag.props.onSubmit(createAnalysisRequest(values, bag.props.stepId, pipelineType, template == null ? void 0 : template.isUTC), values.subscribers);
  })
};
const isAnalysisDatesSupported = (analysisTemplateType) => {
  return ___default.every(
    [AnalysisTemplateTypeDto.RetrospectiveAA, AnalysisTemplateTypeDto.AAStream, AnalysisTemplateTypeDto.SeedFinder],
    (t) => t !== analysisTemplateType
  );
};
const isSegmentsSupported = (analysisTemplateType) => {
  return ___default.every(
    [
      AnalysisTemplateTypeDto.RetrospectiveAA,
      AnalysisTemplateTypeDto.AAStream,
      AnalysisTemplateTypeDto.SeedFinder,
      AnalysisTemplateTypeDto.ForayApp
    ],
    (t) => t !== analysisTemplateType
  );
};
const isTriggerFilterSupported = (analysisTemplateType) => {
  return ___default.every(
    [
      AnalysisTemplateTypeDto.RetrospectiveAA,
      AnalysisTemplateTypeDto.AAStream,
      AnalysisTemplateTypeDto.SeedFinder,
      AnalysisTemplateTypeDto.ForayApp
    ],
    (t) => t !== analysisTemplateType
  );
};
const isWhereClauseSupported = (analysisTemplateType) => {
  return ___default.every(
    [
      AnalysisTemplateTypeDto.RetrospectiveAA,
      AnalysisTemplateTypeDto.AAStream,
      AnalysisTemplateTypeDto.SeedFinder,
      AnalysisTemplateTypeDto.ForayApp
    ],
    (t) => t !== analysisTemplateType
  );
};
const isSupportFilesSupported = (analysisTemplateType) => {
  return ___default.every(
    [
      AnalysisTemplateTypeDto.RetrospectiveAA,
      AnalysisTemplateTypeDto.AAStream,
      AnalysisTemplateTypeDto.SeedFinder,
      AnalysisTemplateTypeDto.ForayApp
    ],
    (t) => t !== analysisTemplateType
  );
};
const isJobSettingsSupported = (analysisTemplateType) => {
  return ___default.every(
    [
      AnalysisTemplateTypeDto.RetrospectiveAA,
      AnalysisTemplateTypeDto.AAStream,
      AnalysisTemplateTypeDto.SeedFinder,
      AnalysisTemplateTypeDto.ForayApp
    ],
    (t) => t !== analysisTemplateType
  );
};
const isJobProfileSideStreamSupported = (analysisTemplate) => {
  if (!!analysisTemplate) {
    if (isJobProfileBasedTemplate(analysisTemplate) && !!analysisTemplate.jobProfiles && analysisTemplate.jobProfiles.length > 1) {
      return analysisTemplate.triggerFilterConfigs.length > 0 || analysisTemplate.jobProfiles.every(
        (jobProfile) => !!jobProfile.triggerFilterConfigs && jobProfile.triggerFilterConfigs.length > 0
      );
    }
    return false;
  }
  return false;
};
const isValidationNeeded = (values) => {
  return values.templateSelectedType !== AnalysisTemplateTypeDto.ForayApp && (values.isEnabledTriggerFilter || values.isAdditionalWhereClauseEnabled || values.customSegments.length > 0) && !values.isMergedJobProfilePresent && !values.isJobProfileSideStreamEnabled;
};
const isSideStreamSupported = (triggerFilterType, requestForm, pipelineType, isStudio) => {
  return !isStudio && triggerFilterType === TriggerFilterType.Triggered && pipelineType !== ComputePipelineType.AzureSpark;
};
const getAnalysisTemplateV2 = (templateName, templateNameV2DictAsync) => {
  var _a, _b;
  if (!!templateName && !!templateNameV2DictAsync) {
    return (_b = (_a = templateNameV2DictAsync[templateName]) == null ? void 0 : _a.data) != null ? _b : null;
  }
  return null;
};
const getAnalysisTemplateLink = (workspaceId, templateName, templateNameV2DictAsync) => {
  const template = getAnalysisTemplateV2(templateName, templateNameV2DictAsync);
  return !!template ? getVivaceAnalysisTemplateLink(workspaceId, template.metricSetName || "", templateName) : getVivaceAnalysisTemplateLink(workspaceId, "", "");
};
const getAutomaticTaskViewsFromTemplateV2 = (template) => {
  var _a;
  const tasks = ((_a = template == null ? void 0 : template.taskSchedule) == null ? void 0 : _a.tasks) || [];
  return tasks.map((task) => {
    var _a2, _b;
    const scorecardPurpose = task.scorecardPurpose !== ScorecardPurpose.Unknown ? task.scorecardPurpose || "" : "";
    const taskTypeStr = task.type || "-";
    const typeAttr = `${taskTypeStr} ${!!scorecardPurpose ? "[" + scorecardPurpose + "]" : ""}`.trim();
    const start = ((_a2 = task.start) == null ? void 0 : _a2.toLocaleString()) || "";
    const end = ((_b = task.end) == null ? void 0 : _b.toLocaleString()) || "";
    let duration = typeAttr;
    if (!!start || !!end) {
      duration = start + " - " + end + " " + duration;
    }
    return {
      type: typeAttr,
      duration
    };
  });
};
const getPrimarySegmentsV2 = (template) => {
  const primarySegments = findSegmentsAtLevel(template, 1);
  return primarySegments.length > 0 ? primarySegments[0] : "";
};
const getSecondarySegmentsV2 = (template) => {
  const secondarySegments = findSegmentsAtLevel(template, 2);
  if (secondarySegments.length > 0) {
    return secondarySegments;
  } else {
    return [];
  }
};
const getComputePipelineFromDataSource = (v2Contract) => {
  var _a;
  if (v2Contract && (v2Contract == null ? void 0 : v2Contract.jobProfiles) && ((_a = v2Contract == null ? void 0 : v2Contract.jobProfiles) == null ? void 0 : _a.length)) {
    const computePipeline = v2Contract.jobProfiles[0].computePipeline;
    return computePipeline;
  } else
    return void 0;
};
const getJobProfileSideStreamFromTemplate = (template) => {
  var _a;
  return (_a = template == null ? void 0 : template.jobProfiles) == null ? void 0 : _a.map((jobProfile) => {
    var _a2;
    const jobProfileDisplayName = jobProfile.displayName;
    const sideStreamName = !!((_a2 = jobProfile.triggerFilterConfigs) == null ? void 0 : _a2.length) && jobProfile.triggerFilterConfigs.length > 0 ? jobProfile.triggerFilterConfigs[0].name : template.triggerFilterConfigs[0].name;
    return {
      sideStreamName,
      jobProfileDisplayName
    };
  });
};
const isJobProfileBasedTemplate = (template) => {
  var _a;
  if (template && (template == null ? void 0 : template.jobProfiles) && ((_a = template == null ? void 0 : template.jobProfiles) == null ? void 0 : _a.length)) {
    return true;
  }
  return false;
};
const findSegmentsAtLevel = (template, level) => {
  if (!template || !template.segmentBy || template.segmentBy.length === 0) {
    return [];
  }
  const segmentAtLevel = template.segmentBy.find((s) => s.level.toLocaleString() === level.toLocaleString());
  if (!segmentAtLevel || !segmentAtLevel.segments) {
    return [];
  }
  return segmentAtLevel.segments.map((s) => s.name);
};
const getAnalysisTemplateV2DtoFromXML = (templateXml) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  if (!templateXml) {
    return void 0;
  }
  let v2Contract = getDefaultAnalysisTemplateV2Dto();
  const parser = new DOMParser();
  const parsed = parser.parseFromString(templateXml, "text/xml");
  const analysisTemplateNames = Array.from(parsed.getElementsByTagName("name"));
  if (((_a = analysisTemplateNames == null ? void 0 : analysisTemplateNames.length) != null ? _a : 0) > 0) {
    v2Contract.name = analysisTemplateNames[0].innerHTML;
  }
  const analysisTemplateDescriptions = Array.from(parsed.getElementsByTagName("description"));
  if (((_b = analysisTemplateDescriptions == null ? void 0 : analysisTemplateDescriptions.length) != null ? _b : 0) > 0) {
    v2Contract.description = analysisTemplateDescriptions[0].innerHTML;
  }
  const analysisTypes = Array.from(parsed.getElementsByTagName("analysisType"));
  if (((_c = analysisTypes == null ? void 0 : analysisTypes.length) != null ? _c : 0) > 0) {
    v2Contract.analysisType = getAnalysisType(analysisTypes[0]);
  }
  const metricSetNames = Array.from(parsed.getElementsByTagName("primaryDataSource"));
  if (((_d = metricSetNames == null ? void 0 : metricSetNames.length) != null ? _d : 0) > 0) {
    v2Contract.metricSetName = metricSetNames[0].innerHTML;
  }
  const LayoutNames = Array.from(parsed.getElementsByTagName("verticalFilter"));
  if (((_e = LayoutNames == null ? void 0 : LayoutNames.length) != null ? _e : 0) > 0) {
    v2Contract.layoutName = LayoutNames[0].innerHTML;
  }
  const virtualClusters = Array.from(parsed.getElementsByTagName("vc"));
  if (((_f = virtualClusters == null ? void 0 : virtualClusters.length) != null ? _f : 0) > 0) {
    v2Contract.virtualCluster = virtualClusters[0].innerHTML;
  }
  const computePipelines = Array.from(parsed.getElementsByTagName("ComputePipeline"));
  if (((_g = computePipelines == null ? void 0 : computePipelines.length) != null ? _g : 0) > 0 && computePipelines[0].innerHTML === "AzureExpSpark") {
    v2Contract.computePipeline = ComputePipelineType.AzureSpark;
  } else {
    v2Contract.computePipeline = ComputePipelineType.Cosmos;
  }
  const triggerFilterConditions = Array.from(parsed.getElementsByTagName("triggerFilterCondition"));
  if (((_h = triggerFilterConditions == null ? void 0 : triggerFilterConditions.length) != null ? _h : 0) > 0) {
    v2Contract.triggerFilterCondition = getTriggerFilterInfo(triggerFilterConditions[0]);
  }
  const triggerFilterConfigs = Array.from(parsed.getElementsByTagName("triggerFilterConfig"));
  if (((_i = triggerFilterConfigs == null ? void 0 : triggerFilterConfigs.length) != null ? _i : 0) > 0) {
    v2Contract.triggerFilterConfigs = getSideStreamTriggerFilterInfos(triggerFilterConfigs);
  }
  const segmentGroupsArr = Array.from(parsed.getElementsByTagName("segmentGroups"));
  if (((_j = segmentGroupsArr == null ? void 0 : segmentGroupsArr.length) != null ? _j : 0) > 0) {
    v2Contract.segmentGroups = getSegmentGroups(
      segmentGroupsArr.filter((element) => {
        var _a2;
        return ((_a2 = element.parentElement) == null ? void 0 : _a2.tagName) === "template";
      })
    );
  }
  const segmentByArr = Array.from(parsed.getElementsByTagName("segmentBy"));
  if (((_k = segmentByArr == null ? void 0 : segmentByArr.length) != null ? _k : 0) > 0) {
    const segmentSet = Array.from(segmentByArr[0].querySelectorAll("segmentSet"));
    v2Contract.segmentBy = ((_l = segmentSet == null ? void 0 : segmentSet.length) != null ? _l : 0) > 0 ? segmentSet.map((segmentSetElement) => getSegmentLevelData(segmentSetElement)) : null;
  }
  const scheduleDefinitionArr = Array.from(parsed.getElementsByTagName("scheduleDefinition"));
  if (((_m = scheduleDefinitionArr == null ? void 0 : scheduleDefinitionArr.length) != null ? _m : 0) > 0) {
    v2Contract.taskSchedule = getTaskSchedule(scheduleDefinitionArr[0]);
  }
  v2Contract.forayAppParams = getForaAppParams(parsed);
  return v2Contract;
};
const getForaAppParams = (document) => {
  var _a, _b;
  const forayAppPages = Array.from(document.getElementsByTagName("ForayAppPage"));
  const workflows = Array.from(document.getElementsByTagName("Workflow"));
  return {
    forayAppPage: ((_a = forayAppPages == null ? void 0 : forayAppPages.length) != null ? _a : 0) > 0 ? forayAppPages[0].innerHTML : "",
    workflow: ((_b = workflows == null ? void 0 : workflows.length) != null ? _b : 0) > 0 ? getForayWorkflowParams(workflows[0]) : null,
    internal: ""
  };
};
const getForayWorkflowParams = (element) => {
  var _a, _b;
  const ids = Array.from(element.getElementsByTagName("Id"));
  const types = Array.from(element.getElementsByTagName("Type"));
  return {
    id: ((_a = ids == null ? void 0 : ids.length) != null ? _a : 0) > 0 ? ids[0].innerHTML : "",
    type: ((_b = types == null ? void 0 : types.length) != null ? _b : 0) > 0 ? types[0].innerHTML : "",
    customParameters: {}
  };
};
const getAnalysisType = (element) => {
  switch (element.innerHTML) {
    case "ForayApp":
      return AnalysisTemplateTypeDto.ForayApp;
    case "Interleaving":
      return AnalysisTemplateTypeDto.Interleaving;
    case "SeedFinder":
      return AnalysisTemplateTypeDto.SeedFinder;
    default:
      return AnalysisTemplateTypeDto.AB;
  }
};
const getSideStreamTriggerFilterInfos = (elements) => {
  var _a;
  if (((_a = elements == null ? void 0 : elements.length) != null ? _a : 0) === 0) {
    return [];
  }
  return elements.map((element) => getTriggerFilterConfig(Array.from(element.querySelectorAll("name"))));
};
const getTaskSchedule = (element) => {
  var _a;
  return {
    isUTC: null,
    roundingRule: (element == null ? void 0 : element.attributes) && ((_a = element == null ? void 0 : element.attributes["roundingRule"]) == null ? void 0 : _a.nodeValue) || null,
    tasks: getTasksFromTemplateXML(Array.from(element == null ? void 0 : element.getElementsByTagName("task")))
  };
};
const getTasksFromTemplateXML = (elements) => {
  var _a;
  if (((_a = elements == null ? void 0 : elements.length) != null ? _a : 0) === 0) {
    return [];
  }
  return elements.map((element) => getTaskDTO(element));
};
const getTaskDTO = (element) => {
  var _a, _b, _c, _d;
  return {
    type: (element == null ? void 0 : element.attributes) && ((_a = element == null ? void 0 : element.attributes["type"]) == null ? void 0 : _a.nodeValue) || null,
    start: (element == null ? void 0 : element.attributes) && ((_b = element == null ? void 0 : element.attributes["start"]) == null ? void 0 : _b.nodeValue) || null,
    end: (element == null ? void 0 : element.attributes) && ((_c = element == null ? void 0 : element.attributes["end"]) == null ? void 0 : _c.nodeValue) || null,
    scorecardPurpose: (element == null ? void 0 : element.attributes) && ((_d = element == null ? void 0 : element.attributes["scorecardPurposeUsedForPrioritization"]) == null ? void 0 : _d.nodeValue) || null
  };
};
const getTriggerFilterInfo = (element) => {
  var _a, _b;
  return {
    type: (element == null ? void 0 : element.attributes) && ((_a = element == null ? void 0 : element.attributes["type"]) == null ? void 0 : _a.nodeValue) || "",
    name: (element == null ? void 0 : element.attributes) && ((_b = element == null ? void 0 : element.attributes["name"]) == null ? void 0 : _b.nodeValue) || "",
    scopeExpression: (element == null ? void 0 : element.textContent) || ""
  };
};
const getTriggerFilterConfig = (elements) => {
  var _a;
  return {
    name: ((_a = elements == null ? void 0 : elements.length) != null ? _a : 0) > 0 ? elements[0].innerHTML : ""
  };
};
const getSegmentLevelData = (element) => {
  var _a, _b, _c, _d;
  return {
    aggregateAll: (_b = (element == null ? void 0 : element.attributes) && ((_a = element == null ? void 0 : element.attributes["aggregateAll"]) == null ? void 0 : _a.nodeValue) === "true") != null ? _b : false,
    level: (_d = (element == null ? void 0 : element.attributes) && ((_c = element == null ? void 0 : element.attributes["level"]) == null ? void 0 : _c.nodeValue)) != null ? _d : 1,
    segmentGroups: getSegmentGroups(Array.from(element == null ? void 0 : element.querySelectorAll("segmentGroups"))),
    segments: getSegments(Array.from(element == null ? void 0 : element.querySelectorAll("segment")))
  };
};
const getSegmentGroups = (elements) => {
  var _a;
  if (((_a = elements == null ? void 0 : elements.length) != null ? _a : 0) === 0) {
    return [];
  }
  let segmentGroupsArr = [];
  elements.forEach((element) => {
    const segmentGrpsArr = element.innerHTML.split(",");
    segmentGrpsArr.forEach((sg) => segmentGroupsArr.push(sg.trim()));
  });
  return segmentGroupsArr.filter((sg) => !!sg);
};
const getSegments = (elements) => {
  var _a;
  if (((_a = elements == null ? void 0 : elements.length) != null ? _a : 0) === 0) {
    return [];
  }
  let segmentNamesArr = [];
  elements.forEach((element) => {
    const nameElements = Array.from(element.querySelectorAll("name"));
    nameElements.forEach((nameElement) => segmentNamesArr.push(getSegmentName(nameElement.innerHTML)));
  });
  return segmentNamesArr;
};
const getSegmentName = (name) => ({
  name
});
let getDefaultAnalysisTemplateV2Dto = () => ({
  name: "",
  workspaceId: "",
  description: "",
  analysisType: AnalysisTemplateTypeDto.AB,
  layoutName: "",
  virtualCluster: "",
  metricSetName: "",
  metricSetVersion: "",
  isUTC: true,
  maxAnalysisWindowInHours: 0,
  segmentBy: [],
  segments: [],
  segmentGroups: null,
  computePipeline: ComputePipelineType.AzureSpark,
  triggerFilterCondition: null,
  triggerFilterConfigs: [],
  forayAppParams: null,
  metricCategories: [],
  taskSchedule: null,
  jobProfiles: [],
  mergedJobProfiles: []
});
const segmentDictionaryKey = (metricSetName, metricSetVersion) => {
  return metricSetName + "##" + metricSetVersion;
};
const getTemplate = (requestForm, templateName) => {
  var _a, _b;
  const template = (_b = (_a = requestForm == null ? void 0 : requestForm.AnalysisRequestForm) == null ? void 0 : _a.AvailableTemplates) == null ? void 0 : _b.find((a) => a.Name === templateName);
  return template;
};
const alignToDayBoundary = (date) => {
  let newDate = new Date(date);
  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);
  if (date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0 || date.getMilliseconds() !== 0) {
    newDate.setDate(date.getDate() + 1);
  }
  return newDate;
};
const containsNonAsciiCharacters = (inputString) => {
  return !/^[\u0000-\u007f]*$/.test(inputString);
};
const sanitizeOneOffTime = (date) => {
  if (!date)
    return date;
  const sanitizedDate = new Date(date);
  sanitizedDate.setSeconds(0);
  sanitizedDate.setMilliseconds(0);
  return sanitizedDate;
};
const getMetricSetVersionNameFromVersionId = (metricSetVersionResult, metricSetVersionId) => {
  var _a, _b;
  if (!metricSetVersionId) {
    return "";
  }
  return (_b = (_a = metricSetVersionResult == null ? void 0 : metricSetVersionResult.Data.find((d) => d.MetricSetId === metricSetVersionId)) == null ? void 0 : _a.VersionName) != null ? _b : "";
};
const toUTC = (localDate) => {
  if (!localDate)
    return void 0;
  return new Date(localDate.getTime() + localDate.getTimezoneOffset() * 6e4);
};
const toPST = (localDate) => {
  if (!localDate)
    return void 0;
  const isPDT = isDaylightSavingTime(localDate);
  const hourOffset = isPDT ? 7 : 8;
  return new Date(localDate.getTime() + localDate.getTimezoneOffset() * 6e4 - hourOffset * 36e5);
};
const toLocalFromUTC = (utcDate) => {
  if (!utcDate)
    return void 0;
  return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 6e4);
};
const toLocalFromPST = (pstDate) => {
  if (!pstDate)
    return void 0;
  const isPDT = isDaylightSavingTime(pstDate);
  const hourOffset = isPDT ? 7 : 8;
  return new Date(pstDate.getTime() - pstDate.getTimezoneOffset() * 6e4 + hourOffset * 36e5);
};
const getTimeZoneEndingUTC = (localDate) => {
  let modifiedDate = `${localDate == null ? void 0 : localDate.toString().substring(0, localDate == null ? void 0 : localDate.toString().indexOf("GMT")).trim()} GMT-0000 (UTC)`;
  if (!localDate) {
    return void 0;
  }
  return modifiedDate;
};
const getTimeZoneEndingPST = (localDate) => {
  if (!localDate) {
    return void 0;
  }
  const isPDT = isDaylightSavingTime(localDate);
  const gmtOffset = isPDT ? "GMT-0700" : "GMT-0800";
  const timeZoneName = isPDT ? "Pacific Daylight Time" : "Pacific Standard Time";
  return `${localDate.toString().substring(0, localDate.toString().indexOf("GMT")).trim()} ${gmtOffset} (${timeZoneName})`;
};
const isDaylightSavingTime = (date) => {
  return momentTz(date).tz("America/Los_Angeles").isDST();
};
export {
  toLocalFromUTC as $,
  AnalysisCreateFormSettings as A,
  parseSecondarySegments as B,
  getInitialCreateFormValues as C,
  sanitizeOneOffTime as D,
  getAutomaticTaskViewsFromTemplateV2 as E,
  toUTC as F,
  toPST as G,
  isDaylightSavingTime as H,
  alignToDayBoundary as I,
  JoinColumnPairDefaults as J,
  getTemplate as K,
  isSideStreamSupported as L,
  getJobProfileSideStreamFromTemplate as M,
  getAnalysisTemplateLink as N,
  CustomParameterDefaults as O,
  getForayAppJobProperties as P,
  getSegmentsByOverride as Q,
  getTriggerFilterInfo$1 as R,
  getCustomData as S,
  TriggerFilterType as T,
  getCommonInitialCreateFormValues as U,
  getABInitialCreateFormValues as V,
  getFilterValue as W,
  isValidAnalysisDateTab as X,
  isValidSideStreamForm as Y,
  getTriggerFilterType as Z,
  containsNonAsciiCharacters as _,
  getPrimarySegmentsV2 as a,
  toLocalFromPST as a0,
  getSecondarySegmentsV2 as b,
  parseSideStreamInfo as c,
  convertToAnalysisCreateV2 as d,
  getMetricSetVersionNameFromVersionId as e,
  createForayJobValidationRequest as f,
  getAnalysisTemplateV2DtoFromXML as g,
  getForayAppInitialCreateFormValues as h,
  getAnalysisTemplateV2 as i,
  getComputePipelineFromDataSource as j,
  createAnalysisRequest as k,
  isValidationNeeded as l,
  getTimeZoneEndingUTC as m,
  getTimeZoneEndingPST as n,
  isAnalysisDatesSupported as o,
  parseTriggerFilterCondition as p,
  isSegmentsSupported as q,
  isJobProfileSideStreamSupported as r,
  segmentDictionaryKey as s,
  isTriggerFilterSupported as t,
  isWhereClauseSupported as u,
  isSupportFilesSupported as v,
  isJobProfileBasedTemplate as w,
  isJobSettingsSupported as x,
  parseTriggerFilterInfoDto as y,
  parsePrimarySegments as z
};
//# sourceMappingURL=AnalysisFormUtils-724038a8.js.map
